/**
 * Returns a card-optimized image URL (smaller size, lower quality) for faster loading in grids.
 * Only rewrites Firebase Storage URLs; other URLs (placeholders, relative paths) are returned as-is.
 */

const CARD_IMAGE_WIDTH = 480;
const CARD_IMAGE_HEIGHT = 480;
const CARD_IMAGE_QUALITY = 72;

const FIREBASE_STORAGE_HOST = 'firebasestorage.googleapis.com';

/**
 * @param {string} url - Original image URL
 * @returns {string} - URL optimized for card display, or original if not applicable
 */
export function getCardImageUrl(url) {
  if (!url || typeof url !== 'string' || url.startsWith('/') || url.startsWith('data:')) {
    return url || '';
  }
  try {
    const parsed = new URL(url);
    if (!parsed.hostname.includes(FIREBASE_STORAGE_HOST)) {
      return url;
    }
    const resizeBase = 'https://wsrv.nl/';
    const params = new URLSearchParams({
      url: url,
      w: String(CARD_IMAGE_WIDTH),
      h: String(CARD_IMAGE_HEIGHT),
      fit: 'cover',
      n: '-1',
      q: String(CARD_IMAGE_QUALITY),
    });
    return `${resizeBase}?${params.toString()}`;
  } catch {
    return url;
  }
}
